<agr-summary-card
  [actions]="cardActions"
  [title]="'environmentalImpactPointsTitle' | translate"
  class="list-summary-card"
>
  <mat-form-field class="full-width-field">
    <mat-label>{{ 'cropField' | translate }}</mat-label>
    <mat-select (valueChange)="onCropFieldChanged()" [(value)]="selectedCropFieldId">
      @for (cropField of cropFields$ | async; track cropField) {
        <mat-option [value]="cropField.id">
          {{ cropField.name }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
  @if (!selectedEnvironmentalImpactWithBenchmark) {
    <agr-notification-empty [isEmpty]="true"></agr-notification-empty>
  }
  @if (selectedEnvironmentalImpactWithBenchmark) {
    <dl class="spacing--margin-none-top spacing--margin-bottom">
      <dt class="text--label">{{ 'environmentalImpactPointsAquaticLife' | translate }}</dt>
      <dd class="text--bold text--h4">
        {{ selectedEnvironmentalImpactWithBenchmark.environmentalImpactReport.totals.aquaticLife | number: '1.0-0' }}
        /<span class="text--light text--h5">{{
          selectedEnvironmentalImpactWithBenchmark.benchmark?.aquaticLifeMean
            ? (selectedEnvironmentalImpactWithBenchmark.benchmark?.aquaticLifeMean | number: '1.0-0')
            : '-'
        }}</span>
      </dd>
      <dt class="text--label">{{ 'environmentalImpactPointsSoilLife' | translate }}</dt>
      <dd class="text--bold text--h4">
        {{ selectedEnvironmentalImpactWithBenchmark.environmentalImpactReport.totals.soilLife | number: '1.0-0' }}/<span
          class="text--light text--h5"
          >{{
            selectedEnvironmentalImpactWithBenchmark.benchmark?.soilLifeMean
              ? (selectedEnvironmentalImpactWithBenchmark.benchmark?.soilLifeMean | number: '1.0-0')
              : '-'
          }}</span
        >
      </dd>
      <dt class="text--label">
        {{ 'environmentalImpactPointsGroundWaterWashout' | translate }}
      </dt>
      <dd class="text--bold text--h4">
        {{
          selectedEnvironmentalImpactWithBenchmark.environmentalImpactReport.totals.groundwaterWashout
            | number: '1.0-0'
        }}/<span class="text--light text--h5">{{
          selectedEnvironmentalImpactWithBenchmark.benchmark?.groundwaterWashoutMean
            ? (selectedEnvironmentalImpactWithBenchmark.benchmark?.groundwaterWashoutMean | number: '1.0-0')
            : '-'
        }}</span>
      </dd>
      <dt class="text--label crop-year">{{ 'year' | translate }}</dt>
      <dd class="text--bold text--h4 crop-year">{{ cropYear() }}</dd>
    </dl>
    @if (dataSource && chartOptions) {
      <agr-chart [dataSource]="dataSource" [options]="chartOptions"></agr-chart>
    }
    @if (informationTooltipText) {
      <mat-icon [matTooltip]="informationTooltipText" class="information-tooltip">help_outline </mat-icon>
    }
    <mat-divider></mat-divider>
    <div class="spacing--padding-horizontal spacing--padding-top spacing--margin-half-bottom flex--row">
      <div class="text--label">
        <button (click)="openEnvironmentalImpactReportDialog()" data-test="more-details-button" mat-button>
          <mat-icon>arrow_forward</mat-icon>
          {{ 'moreDetails' | translate }}
        </button>
      </div>
      <div class="crop-title">
        <div class="text--label">{{ 'crop' | translate }}</div>
        <div class="text--bold">
          {{ selectedEnvironmentalImpactWithBenchmark.environmentalImpactReport.cropName }}
          @if (selectedEnvironmentalImpactWithBenchmark.environmentalImpactReport.cropVarietyName) {
            <span>({{ selectedEnvironmentalImpactWithBenchmark.environmentalImpactReport.cropVarietyName }})</span>
          }
        </div>
      </div>
    </div>
  }
</agr-summary-card>
